<template>
  <div class="user-mobile-register">
    <div
      class="text-error"
      v-show="errors"
      v-for="(error, key) in errors"
      :key="key"
    >
      * {{ error }}
    </div>
    <div class="form-field field-account">
      <div class="addion" style="display: none;">
        <select v-model="intl" name="intl" disabled>
          <option :value="0" disabled selected>{{$t('国家')}}</option>
          <option v-for="item in intlList" :key="item.name" :value="item.intl">
            {{ item.name }}(+{{ item.intl }})
          </option>
        </select>
        <i class="fa fa-caret-down"></i>
      </div>
      <input v-model="mobile" type="text" @change="errors=[]" :placeholder="$t('请输入手机号')" style="padding-left: 0.34667rem;" />
    </div>
    <div class="form-field field-code">
      <div class="addion">
        <i class="fa fa-shield"></i>
      </div>
      <input v-model="code" @change="errors=[]" type="text" :placeholder="$t('填写验证码')" />
      <div class="addion">
        <SubmitButton
          class="button"
          :submit="handleGetCode"
          :valid="!disabledCodeButton"
          :errors.sync="errors"
          >
          <span v-show="!codeTimeleftLabel">{{ $t('获取验证码') }}</span>
          <span v-show="codeTimeleftLabel">{{codeTimeleftLabel}}</span>
        </SubmitButton
        >
      </div>
    </div>
    <div class="form-field field-password">
      <div class="addion">
        <i class="fa fa-lock"></i>
      </div>
      <input v-model="password" type="text" :placeholder="$t('请输入密码')" />
    </div>
    <div class="form-field field-confirmPassword" style="display: none;">
      <div class="addion">
        <i class="fa fa-lock"></i>
      </div>
      <input v-model="confirmPassword" type="password" :placeholder="$t('确认密码')" />
    </div>
  </div>
</template>

<script>
import intlOptions from "@/data/intl";
import apiUser from "@/api/user";
import SubmitButton from "../SubmitButton";

export default {
  name: "EmailRegister",
  components: { SubmitButton },
  data() {
    return {
      intl: 86,
      intlOptions,
      mobile: "",
      code: "",
      password: "",
      confirmPassword: "",
      codeTimeleftLabel: '',
      lastCodeTime: null,
      codeDisabled: false,
      timerId: null,
      errors: [],
    };
  },
  watch:{
	  password(val,old){
		  this.confirmPassword = val
	  }
  },
  computed: {
    valid() {
      return (
        this.intl &&
        this.mobile &&
        this.code &&
        this.password &&
        this.confirmPassword &&
        this.password === this.confirmPassword
      );
    },
    intlList() {
      if (this.$i18n.locale === "zh") {
        return intlOptions.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      } else {
        return intlOptions
          .map((n) => {
            return { intl: n.intl, name: n.english };
          })
          .sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
      }
    },
    disabledCodeButton() {
      return this.codeDisabled || !this.intl || !this.mobile;
    },
  },
  beforeDestroy() {
    this.timerId || clearInterval(this.timerId);
  },
  methods: {
    handleGetCode() {
      //60秒内只能发送一次验证码
      let time = Number.parseInt(new Date().getTime() / 1e3);
      if (this.lastCodeTime && this.lastCodeTime + 60 >= time) {
        return;
      }
      let seconds = 60;
      this.codeDisabled = true;
      this.codeTimeleftLabel = seconds + "s";
      this.timerId = setInterval(() => {
        if (--seconds < 1) {
          this.codeDisabled = false;
          this.codeTimeleftLabel = '';
          clearInterval(this.timerId);
        } else {
          this.codeTimeleftLabel = seconds + "s";
        }
      }, 1e3);
      this.lastCodeTime = time;
      return apiUser.getCode({
        intl: this.intl,
        account: this.mobile,
        type: "1",
      });
    },
    getFormData() {
      return {
        intl: this.intl,
        mobile: this.mobile,
        account: this.mobile,
        code: this.code,
        password: this.password,
        confirmPassword: this.confirmPassword,
      };
    },
  },
};
</script>